import React from 'react';

const backdrop = (props) => !props.show ? null : <div className="Backdrop" onClick={props.clicked} />;

export default backdrop;